<template>
  <div id="ponto-interesse-edit">
    <vs-popup title="Ocorrências" :active.sync="popUpOcorrencias.popupActive">
        <div class="vx-row mb-3">
            <div class="vx-col w-3/4">
                <v-select                                     
                    label="nome"                      
                    :placeholder="$t('TelaItinerario_lTipoOcorrencia')"
                    :options="listaTipoOcorrencia"                   
                    v-model="tipoOcorrenciaSelecionada"       
                    class="v-select w-full"></v-select> 
            </div>
            <div class="vx-col w-1/4">
                <vs-button  type="filled" color="success" :disabled="!temPermissaoGravar && !temCapacidadeMaster || !tipoOcorrenciaSelecionada" @click="adicionarNovaOcorrencia()" icon-pack="feather" icon="icon-plus"></vs-button>                     
            </div>
        </div>       
        <div class="vx-row" >
            <div class="vx-col w-full mb-2">     
                <vs-table maxItems="6" hoverFlat stripe :data="dadosDaGridOcorrencias" v-if="dadosDaGridOcorrencias" noDataText="..." :pagination="true">
                    <template slot="thead">
                        <vs-th>Tipo</vs-th>
                        <vs-th>Cadastrado</vs-th>
                        <vs-th>Tratatado</vs-th>
                        <vs-th>Status</vs-th>
                    </template>

                    <template slot-scope="{data}"> 
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                            <vs-td :data="data[indextr].tipoErro.nome">
                                <small>{{data[indextr].tipoErro.nome}}</small>
                                <template slot="edit">                                      
                                      <vs-textarea v-model="tr.tratativa" height="80px"  maxlength="2048"/>                        
                                </template>
                            </vs-td>

                            <vs-td :data="data[indextr].dataHoraCadastro">
                                <small>{{data[indextr].dataHoraCadastro}}</small>
                            </vs-td>

                            <vs-td :data="data[indextr].dataHoraAlteracao">
                                <small>{{data[indextr].dataHoraAlteracao}}</small>
                            </vs-td>

                            <vs-td :data="data[indextr].status">
                                <small>{{data[indextr].status}}</small>
                                <template slot="edit">
                                       <vs-radio v-model="tr.status" vs-value="PENDENTE" class="mr-4">Pendente</vs-radio>
                                       <vs-radio v-model="tr.status" vs-value="TRATADO">Tratado</vs-radio>
                                </template>
                            </vs-td>
                            </vs-tr>
                    </template> 
                </vs-table>                          
            </div>   
        </div> 
        <div class="vx-row">
          <vs-button class="ml-4 mt-2" type="border" size="small" @click="listaOcorrenciasDaViagem" color="dark">{{ $t('Pesquisa') }}</vs-button>
          <vs-button class="ml-4 mt-2" size="small" :disabled="!temPermissaoGravar && !temCapacidadeMaster || dadosDaGridOcorrencias.length === 0" @click="gravarOcorrenciasViagem" color="success" >{{ $t('Btn_Gravar') }}</vs-button>
        </div>
       
    </vs-popup> 
    <vs-popup title="Início manual da viagem" :active.sync="popUpInicioManualViagem.popupActive">
        <vs-alert :active.sync="popUpInicioManualViagem.exibirMensagem" closable icon-pack="feather" close-icon="icon-x" class="mb-4" icon="icon-info">
            {{popUpInicioManualViagem.mensagem}}
        </vs-alert> 
        <vs-row vs-type="flex" vs-justify="space-between" class="mt-4">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
               Data e Hora de Saída:
            </vs-col>            
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
               Odômetro de Saída:
            </vs-col>            
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <flat-pickr v-model="popUpInicioManualViagem.dataRealizadaSaida" :config="configDateTimePicker"/>    
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full ml-2" v-model="popUpInicioManualViagem.odometroSaida" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0' }]"></vue-autonumeric>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" class="mt-4">            
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
               Horímetro de Saída:
            </vs-col>            
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full ml-2" v-model="popUpInicioManualViagem.horimetroSaida" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0' }]"></vue-autonumeric>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" class="mt-4">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button color="dark" @click="iniciarViagemManual()" :disabled="!popUpInicioManualViagem.dataRealizadaSaida"><feather-icon icon="SaveIcon" svgClasses="h-4 w-4" /> {{$t('Btn_Gravar')}}</vs-button>
            </vs-col>
        </vs-row>        
    </vs-popup> 
    <vs-popup title="Término manual da viagem" :active.sync="popUpTerminoManualViagem.popupActive">
        <vs-alert :active.sync="popUpTerminoManualViagem.exibirMensagem" closable icon-pack="feather" close-icon="icon-x" class="mb-4" icon="icon-info">
            {{popUpTerminoManualViagem.mensagem}}
        </vs-alert> 
        <vs-row vs-type="flex" vs-justify="space-between" class="mt-4">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
               Data e Hora de Retorno:
            </vs-col>            
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
               Odômetro de Retorno ( KM ):
            </vs-col>            
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <flat-pickr v-model="popUpTerminoManualViagem.dataRealizadaRetorno" :config="configDateTimePicker"/>    
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full ml-2" v-model="popUpTerminoManualViagem.odometroRetorno" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0' }]"></vue-autonumeric>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" class="mt-4">            
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
               Horímetro de Retorno ( Horas ):
            </vs-col>            
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
                <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full ml-2" v-model="popUpTerminoManualViagem.horimetroRetorno" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0' }]"></vue-autonumeric>
            </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" class="mt-4">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                <vs-button color="dark" @click="terminoViagemManual()" :disabled="!popUpTerminoManualViagem.dataRealizadaRetorno"><feather-icon icon="SaveIcon" svgClasses="h-4 w-4" /> {{$t('Btn_Gravar')}}</vs-button>
            </vs-col>
        </vs-row>        
    </vs-popup>   
    <vs-popup title="Importação de arquivo XLS" :active.sync="popupImportacaoArquivo">        
        <div class="vx-row mb-4">
            <div class="vx-col w-full flex items-center" >                    
                <file-upload
                    class="btn btn-primary w-full"                            
                    :post-action="getUrlPost"
                    extensions="xls, xlsx"                            
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    :multiple="false"
                    :data="dadosUpload"                    
                    @input-filter="inputFilter"                          
                    v-model="arquivosParaUpload"                             
                    ref="upload">
                    <i class="fa fa-plus"></i> Selecione o arquivo
                </file-upload>
                <vs-button class="ml-4 w-full" size="small" color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-upload" v-if="!$refs.upload || !$refs.upload.active" :disabled="arquivosParaUpload.length === 0 || $refs.upload.uploaded " @click.prevent="$refs.upload.active = true">Importar</vs-button>

                <vs-button class="ml-4 w-full" size="small" v-if="arquivosParaUpload.length > 0 " color="dark" @click="removeArquivoUpload()" >Novo</vs-button>
            </div>            
        </div>
        <vs-row vs-type="flex" vs-justify="center" v-for="file in arquivosParaUpload" :key="file.id">
            <vs-col vs-type="flex" vs-align="center" vs-w="12" vs-justify="center">
                <div class="justify-center w-full">
                    {{file.name}}
                    <div class="op-block w-full text-center">{{exibirMensagelResultadoUpload(file.response)}}</div>
                </div>
            </vs-col>
        </vs-row>
        <div class="mt-4" >
            <feather-icon icon="InfoIcon" svgClasses="w-4 h-4 stroke-current text-primary mr-2" />
            <small>Utilize o arquivo tipo XLS gerado pela rotina 967 (Consultar Carregamento) do WINTHOR com o tipo Resumo de Carregamento por Placa.</small>
        </div>
        
    </vs-popup>   
    <vs-prompt title="Motoristas" :active.sync="configuracaoPopUpMotoristas.exibirPopUpMotorista" v-if="configuracaoPopUpMotoristas.exibirPopUpMotorista"
      @cancel="fecharPopUpMotoristas" @accept="alterarMotorista" @close="fecharPopUpMotoristas"  :is-valid="isPopUpMotoristaValido"
      :acceptText="$t('Btn_OK')" :cancelText="$t('Btn_Fechar')">
      <PopUpMotoristas @selecionarMotorista="onSelecionarMotorista" 
         :tipoSelecao="configuracaoPopUpMotoristas.tipoSelecao" 
         :idVeiculo="configuracaoPopUpMotoristas.idVeiculoSelecionado"
         :mensagemExplicacao="configuracaoPopUpMotoristas.mensagemExplicacao"> 
       </PopUpMotoristas>
    </vs-prompt>
    <vs-prompt title="Itinerário Viagem" :active.sync="configuracaoPopUpItinerarioViagem.exibirPopUp" v-if="configuracaoPopUpItinerarioViagem.exibirPopUp"
      :acceptText="$t('Btn_OK')" :cancelText="$t('Btn_Fechar')">
                <div class="vx-row mb-2" v-if="!data_local.hasOwnProperty('id')">                
                    <div class="vx-col w-full">
                         <label class="vs-input--label" >{{$t('Menu_ControleRotasViagens')}}</label>                        
                         <v-select
                            label="nome"                                     
                            class="v-select w-full"
                            :options="listaRotas" 
                             @input="exibirRotaPreDefinida"
                            :value="rotaControleViagemSelecionada"
                            ></v-select>          
                    </div>     
                </div>
                <div class="vx-row mb-2 mt-2">
                    <div class="vx-col w-full">  
                         <vx-input-group>
                             <template slot="prepend">
                                <div class="prepend-text bg-primary">
                                    <span>{{$t('TelaRotasControleViagem_lPontoInteresse')}}</span>
                                </div>
                            </template>
                             <v-select label="nome" class="v-select w-full" :options="listaPoI" v-model="poiSelecionado" ></v-select>   
                            <template slot="append">
                                <div class="append-text btn-addon">
                                <vs-button color="primary" icon-pack="feather" icon="icon-plus" @click="adicionarPoInaRota()" :disabled="poiSelecionado === null"></vs-button>
                                </div>
                            </template>
                        </vx-input-group>                           
                               
                    </div>               
                </div>
                <div class="vx-row mb-4">
                    <div class="vx-col w-full">
                        <vs-table :data="listaCidadesRota" noDataText="..." class="tabelaComScroll">
                            <template slot="thead">
                                <vs-th></vs-th>
                                <vs-th>Cidade</vs-th>                                
                                <vs-th v-if="!data_local.hasOwnProperty('id')">Ações</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].letra" class="text-sm">
                                        {{ convert(indextr+1) }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].nomeCidade" class="text-sm">
                                        {{ data[indextr].nomeCidade }}
                                    </vs-td>
                                    <vs-td v-if="!data_local.hasOwnProperty('id')">
                                        <div class="btn-group flex">
                                            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-trash" @click="removerCidadeRota(indextr)" v-if="!data_local.hasOwnProperty('id')"></vs-button>
                                            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-arrow-up" @click="moverCidadeAcima(indextr)" :disabled="indextr === 0" v-if="!data_local.hasOwnProperty('id')"></vs-button>
                                            <vs-button size="small" type="filled" icon-pack="feather" icon="icon-arrow-down" @click="moverCidadeAbaixo(indextr)" :disabled="indextr === listaCidadesRota.length -1" v-if="!data_local.hasOwnProperty('id')"></vs-button>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                </div>
    </vs-prompt>
    <vs-prompt title="Tipo Combustível" :active.sync="configuracaoPopUpTipoCombustivel.exibirPopUp" v-if="configuracaoPopUpTipoCombustivel.exibirPopUp"
      @cancel="fecharPopUpTipoCombustivel" @accept="alterarTipoCombustivel" @close="fecharPopUpTipoCombustivel"  :is-valid="isPopUpTipoCombustivelValido"
      :acceptText="$t('Btn_OK')" :cancelText="$t('Btn_Fechar')">
      <PopUpTipoCombustivel @selecionarTipoCombustivel="onSelecionarTipoCombustivel">  </PopUpTipoCombustivel>     
    </vs-prompt>
    <vs-prompt title="Tanque Combustível" :active.sync="configuracaoPopUpTanqueCombustivel.exibirPopUp" v-if="configuracaoPopUpTanqueCombustivel.exibirPopUp"
      @cancel="fecharPopUpTanqueCombustivel" @accept="alterarTanqueCombustivel" @close="fecharPopUpTanqueCombustivel"  :is-valid="isPopUpTanqueCombustivelValido"
      :acceptText="$t('Btn_OK')" :cancelText="$t('Btn_Fechar')">
      <PopUpTanqueCombustivel @selecionarTanqueCombustivel="onSelecionarTanqueCombustivel"></PopUpTanqueCombustivel>     
    </vs-prompt>
    <div style="position:absolute; height: calc(100vh - 65px); width: 50%; right:0px; z-index:2">                      
        <GoogleMapConcept :mapa="map" ref="gmc"></GoogleMapConcept>                      
    </div>
    <div class="vx-row mb-2">
        <div class="vx-col w-1/2">
            <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
            <vx-card>       
                <div class="vx-row mb-2">
                    <div class="vx-col w-2/3">
                        <strong> {{data_local.dadosVeiculo}}</strong>
                    </div>
                    <div class="vx-col w-1/3 flex">
                         <p class="vs-input--label ml-auto">Distância: <br/><strong>{{distanciaFormatada}} </strong>KM</p>
                         <p class="vs-input--label ml-auto">Direção: <br/><strong>{{duracaoFormatada}} </strong></p>
                         <p class="vs-input--label ml-auto">Litros: <br/><strong>{{consumoCombustivelFormatada}} </strong></p>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-1/2">
                        <label class="vs-input--label" >{{$t('TeleControleViagem_lIdentificador')}}</label>
                        <vs-input class="w-full" v-model="data_local.identificadoViagem" />                
                    </div>     
                    <div class="vx-col w-1/2 flex mt-4 items-center">
                         <p class="vs-input--label mr-2 mt-2">Controlar Percurso</p>
                         <vs-switch v-model="data_local.controlarItinerario" class="mt-1" :disabled="data_local.hasOwnProperty('id')">  
                             <span slot="on">SIM</span>
                             <span slot="off">NÃO</span>
                         </vs-switch>
                         <vs-button class="ml-3" color="primary" type="filled" size="small" @click="abrirPopUpItinerarioViagem" v-if="data_local.controlarItinerario">Itinérario</vs-button>
                    </div>     
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-3/4">
                        <vx-input-group>
                            <label class="vs-input--label" >{{$t('TeleControleViagem_lMotorista')}}</label>
                            <vs-input class="w-full" readonly="true" v-model="data_local.condutor" icon-pack="feather" icon="icon-user"/>
                            <template slot="append">
                                <div class="append-text btn-addon mt-5">
                                    <vs-button color="dark"  icon-pack="feather" icon="icon-search" @click="abrirPopUpMotoristas"></vs-button>                                                  
                                </div>
                            </template>
                        </vx-input-group>
                    </div>   
                    <div class="vx-col w-1/4 flex items-center">
                            <vs-checkbox v-model="data_local.alterarMotoristaNoVeiculo"></vs-checkbox>   
                            <label class="vs-input--label">{{$t("TeleControleViagem_lAlterarMotoristaNoVeiculo")}} ?</label>                
                    </div>               
                </div>                
                <div class="vx-row mb-2">
                    <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
                        <label class="vs-input--label" >{{$t('TeleControleViagem_lDataSaida')}}</label>
                        <flat-pickr v-model="data_local.dataPrevistaSaidaEmMilisegundos" class="mb-4 md:mb-0 w-full opacity-75" :config="configDateTimePicker"/>  
                    </div> 
                    <div class="vx-col w-1/3 ">
                        <vx-input-group>
                            <label class="vs-input--label" >{{$t('TeleControleViagem_lDataRetorno')}}</label>
                            <flat-pickr v-model="data_local.dataPrevistaRetornoEmMilisegundos" class="mb-4 md:mb-0 w-full opacity-75" :config="configDateTimePicker" />  
                            <template slot="append">
                                <div class="append-text btn-addon mt-5">
                                    <vs-button color="dark"  icon-pack="feather" icon="icon-calendar" @click="calcularDataRetorno" class="mt-1"></vs-button>
                                </div>
                            </template>
                        </vx-input-group>
                    </div> 
                    <div class="vx-col lg:w-1/3 md:w-1/3 sm:w-1/3 w-full">
                        <label class="vs-input--label">{{$t("TeleControleViagem_lPeriodo")}}</label>
                        <v-select                                       
                            :reduce="tipo => tipo.data "
                            :options="periodoArray"                   
                            v-model="data_local.periodoCarregamento"       
                            class="v-select w-full"></v-select> 
                    </div>  
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full">
                         <label class="vs-input--label" >{{$t('TeleControleViagem_lDe')}}</label>                        
                         <v-select
                            label="nome"         
                            class="v-select w-full"
                            :options="listaPoI" 
                            :disabled="data_local.hasOwnProperty('id')"
                            @input="click_desenharPoISaida"
                            :value="pontoInteresseSaida"></v-select>          
                    </div>  
                </div>                 
                <div class="vx-row mb-2">            
                    <div class="vx-col w-full">
                         <label class="vs-input--label" >{{$t('TeleControleViagem_lPara')}}</label>                        
                         <v-select
                            label="nome"         
                            class="v-select w-full"
                            :options="listaPoI" 
                            :disabled="data_local.hasOwnProperty('id')"
                            @input="click_desenharPoIChegada"
                            :value="pontoInteresseChegada"></v-select>          
                    </div>              
                </div>              
                <div class="vx-row mb-2">            
                    <div class="vx-col w-3/5">
                        <label class="vs-input--label" >Despesa</label>                        
                        <v-select                   
                            :reduce="td => td.tipo" 
                            label="tipo"
                            :options="listaTiposDespesas"                   
                            v-model="data_local.tipoDespesa"                            
                            @input="changeTipoDespesa"   
                            class="v-select w-full">
                        </v-select> 
                    </div>   
                    <div class="vx-col w-1/5"  v-if="data_local.tipoDespesa">
                        <label class="vs-input--label">{{$t("TelaDespesas_lQuantidade")}}</label>
                        <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" v-model="data_local.quantidadeDespesa" :options="[{ emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>
                    </div>     
                    <div class="vx-col w-1/5"  v-if="data_local.tipoDespesa">
                        <label class="vs-input--label">{{$t("TelaDespesas_lValor")}}</label>                
                        <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" v-model="data_local.valorDespesa" :options="[{ emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>
                    </div>           
                </div> 
                <div class="vx-row mb-4">
                    <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full" v-if="exibirCampoTipoCombustivel">
                        <label class="vs-input--label">{{$t("TelaDespesas_lTipoCombustivel")}}</label>
                        <vx-input-group class="w-full" >
                            <vs-input  readonly="true" v-model="tipoCombustivelSelecionado" icon-pack="feather" icon="icon-archive"/>
                            <template slot="append">
                                <div class="append-text btn-addon">
                                    <vs-button color="dark" icon-pack="feather" icon="icon-search" @click="abrirPopUpTipoCombustivel"></vs-button>                                                
                                </div>
                            </template>
                        </vx-input-group>
                    </div>   
                    <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full" v-if="exibirCampoTanqueCombustivel">
                        <label class="vs-input--label">{{$t("TelaDespesas_lTanqueCombustivel")}}</label>
                        <vx-input-group class="w-full" >
                            <vs-input  readonly="true" v-model="tanqueCombustivelSelecionado" icon-pack="feather" icon="icon-archive"/>
                            <template slot="append">
                                <div class="append-text btn-addon">
                                    <vs-button color="dark" icon-pack="feather" icon="icon-search" @click="abrirPopUpTanqueCombustivel" :disabled="data_local.id"></vs-button>                                                
                                </div>
                            </template>
                        </vx-input-group>
                    </div>   
                </div>     
                <div class="vx-row mb-2">            
                    <div class="vx-col w-3/5">
                        <label class="vs-input--label" >Receita</label>                        
                        <v-select                   
                            :reduce="td => td.tipo" 
                            label="tipo"
                            :options="listaTiposReceitas"                   
                            v-model="data_local.tipoReceita"                            
                            class="v-select w-full">
                        </v-select> 
                    </div>   
                    <div class="vx-col w-1/5" v-if="data_local.tipoReceita">
                        <label class="vs-input--label">{{$t("TelaDespesas_lQuantidade")}}</label>
                        <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" v-model="data_local.quantidadeReceita" :options="[{ emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>
                    </div>     
                    <div class="vx-col w-1/5"  v-if="data_local.tipoReceita">
                        <label class="vs-input--label">{{$t("TelaDespesas_lValor")}}</label>                
                        <vue-autonumeric class="vs-inputx vs-input--input normal hasValue w-full" v-model="data_local.valorReceita" :options="[{ emptyInputBehavior: 'null', digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'2' }]"></vue-autonumeric>
                    </div>           
                </div>         
               
                <div class="vx-row mb-4">
                    <div class="vx-col w-full flex">
                        <vx-tooltip :text="getTextoImportacaoValida">
                            <vs-button class="mt-2" size="small" color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-upload" @click="popupImportacaoArquivo = true" :disabled="isImportacaoInvalida">Importar XLS</vs-button>          
                        </vx-tooltip>
                        <vs-button class="mt-2 ml-4" :disabled="!temPermissaoGravar && !temCapacidadeMaster" size="small" @click="gravar" color="success"  v-if="!data_local.hasOwnProperty('dataRealizadaSaidaEmMilisegundos')">{{ $t('Btn_Gravar') }}</vs-button>                        
                        <vs-button class="ml-4 mt-2 mr-4" size="small" type="border" color="dark" @click="voltar">{{ $t('Btn_Voltar') }}</vs-button>                                    
                        <vs-button class="mt-2 mr-4" :disabled="!temPermissaoGravar && !temCapacidadeMaster" size="small" color="warning" icon-pack="feather" icon="icon-play-circle" v-if="data_local.hasOwnProperty('id') && !data_local.hasOwnProperty('dataRealizadaSaidaEmMilisegundos')" @click="abrirPopUpIniciarViagem">Iniciar Manual</vs-button>                                    
                        <vs-button class="mt-2 mr-4" :disabled="!temPermissaoGravar && !temCapacidadeMaster" size="small" color="warning" icon-pack="feather" icon="icon-stop-circle" v-if="data_local.hasOwnProperty('dataRealizadaSaidaEmMilisegundos') && !data_local.hasOwnProperty('dataRealizadaRetornoEmMilisegundos')" @click="abrirPopUpTerminarViagem">Finalizar Manual</vs-button> 
                        <vs-button class="mt-2 mr-4" size="small" color="danger" icon-pack="feather" icon="icon-bell" v-if="data_local.hasOwnProperty('id')" @click="abrirPopUpOcorrencias">Ocorrências</vs-button>                                                                       
                    </div>
                </div>
                
            </vx-card>
        </div>
    </div>  
  </div>
</template>

<script>
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
import generico from '@/generico.js'
import FileUpload from 'vue-upload-component'

const URL_SERVLET = "/ControlarRetornoVeiculosCliente";
const NAME_ROUTE_SEARCH = "controle-viagens-controle-viagem";


export default {  
  components: {  
    flatPickr,
    VueAutonumeric,
    FileUpload
  },   
  props: {
    registroOriginal: {
      type: Object,
      required: true,
      default: function () {
            return {idVeiculo: null, dadosVeiculo: null, placa:null, identificadoViagem: null, qtdCidadesViagem: 0, qtdEntregasViagem: 0, pesoViagem:0, valorTransportado: 0, regiaoAtendida: null,
            condutor: null, periodoCarregamento: null, qtdAjudante: 0, idZonaViagem: null, dataPrevistaSaidaEmMilisegundos: null,
            dataPrevistaRetornoEmMilisegundos: null, valorAdiantamento: 0, dataRealizadaSaidaEmMilisegundos: null,dataRealizadaRetornoEmMilisegundos: null, idMotoristaViagem: null,
            idEquipamentoViagem: null, idEquipamentoViagem2: null, idEquipamentoViagem3: null, statusAceiteMotorista:null, permitirIniciarAntesDoPlanejado: false, permitirAposAceite: false, uuidUltimoHistorico: null,
            autonomia: 0, tipoDespesa: null, quantidadeDespesa: null, valorDespesa: null, tipoReceita: null, quantidadeReceita: null, valorReceita: null,
            odometroAtual: null, horimetroAtual: null, idTipoCombustivel: null, nomeTipoCombustivel: null, idTanqueCombustivel: null, numeroTanqueCombustivel: null, alterarMotoristaNoVeiculo: false , controlarItinerario: false };
       }
    },
  },
  created(){          
    this.periodoArray = [];
    this.periodoArray = generico.criarPeriodos();        
  },
  data() {
    return {             
        map: null,
        errorsValidacao: [],  
        data_local: {identificadoViagem: null, qtdCidadesViagem: 0, qtdEntregasViagem: 0, pesoViagem:0, valorTransportado: 0, regiaoAtendida: null,
            condutor: null, periodoCarregamento: null, qtdAjudante: 0, idZonaViagem: null, dataPrevistaSaidaEmMilisegundos: null,
            dataPrevistaRetornoEmMilisegundos: null, permitirIniciarAntesDoPlanejado: false, placa:null, valorAdiantamento: 0, dataRealizadaSaidaEmMilisegundos: null,
            dataRealizadaRetornoEmMilisegundos: null, idMotoristaViagem: null, idEquipamentoViagem: null, idEquipamentoViagem2: null, idEquipamentoViagem3: null, statusAceiteMotorista: null, permitirAposAceite: false,
            uuidUltimoHistorico: null, autonomia: 0, tipoDespesa: null, quantidadeDespesa: null, valorDespesa: null, tipoReceita: null, quantidadeReceita: null, valorReceita: null,
            odometroAtual: null, horimetroAtual: null, idTipoCombustivel: null, nomeTipoCombustivel: null, idTanqueCombustivel: null, numeroTanqueCombustivel: null, alterarMotoristaNoVeiculo: false, controlarItinerario: false },
        listaPoI : [],
        listaZonas : [],   
        listaRotas : [],   
        listaCidadesRota: [],     
        listaLatLng: [],        
        pontoInteresseSaida: null,
        pontoInteresseChegada: null,
        rotaControleViagemSelecionada: null,
        configuracaoPopUpMotoristas: {
            condutorOriginal: null, 
            exibirPopUpMotorista: false,
            motoristasDoPopUp: null,
            tipoSelecao: "single",
            idVeiculoSelecionado: null,
            mensagemExplicacao: ""
        },
        configuracaoPopUpItinerarioViagem: {            
            exibirPopUp: false            
        },
        configDateTimePicker: {          
          altInput: true,
          altFormat: "d-m-Y H:i",
          dateFormat: "U", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center",
          locale: PortugueseLocale,
          enableTime: true
        },
        saidaMarker: null,
        chegadaMarker: null,
        directionsService: null,
        directionsService2: null,
        directionsService3: null,      
        directionsDisplay: null,
        directionsDisplay2: null,
        directionsDisplay3: null,      
        distanciaTotal: 0,
        duracaoTotal: 0,
        linhaEncoded: '',
        polylineViagem: null,
        renderer_options: {'draggable': true, 'suppressMarkers': true}, 
        renderer_options2: {'draggable': true, 'suppressMarkers': true},
        renderer_options3: {'draggable': true}, 'suppressMarkers': true,
        percursoRotaPath: null,
        arquivosParaUpload: [],
        dadosUpload: { clientId: this.$store.state.AppActiveUser.id, empresaId: this.$store.state.AppActiveUser.idEmpresa, placaVeiculo: null},
        popupImportacaoArquivo: false,
        isArquivoProcessado: false,
        publicPath: process.env.BASE_URL,
        popUpInicioManualViagem: {
            popupActive: false,            
            dataRealizadaSaida: null,
            odometroSaida: 0,
            horimetroSaida: 0,
            exibirMensagem: false,
            mensagem: null
        },  
        popUpTerminoManualViagem: {
            popupActive: false,            
            dataRealizadaRetorno: null,
            odometroRetorno: 0,
            horimetroRetorno: 0,
            exibirMensagem: false,
            mensagem: null
        },  
        listaEquipamentos: [], 
        OPCOES_COMBO_ACEITE_MOTORISTA: [{label:"SIM", data:"S"}, {label:"NÃO", data:"N"}],
        popUpOcorrencias: {
          popupActive: false          
        },
        dadosDaGridOcorrencias: [],
        listaTipoOcorrencia: [],
        tipoOcorrenciaSelecionada: null,
        dialogExibirCalculoDataRetorno: false,
        poiSelecionado: null,
        listaTiposDespesas: [],
        listaTiposReceitas: [],
        configuracaoPopUpTipoCombustivel: {                      
          itensDoPopUp: null,
          exibirPopUp: false,    
        },
        configuracaoPopUpTanqueCombustivel: {                      
          itensDoPopUp: null,
          exibirPopUp: false,    
        },
        listCombustiveisSelecionados: []
    }
  },    
  mounted() {
    this.$vs.loading();
    this.data_local = JSON.parse(JSON.stringify(this.registroOriginal))
    this.dadosUpload.placaVeiculo = this.registroOriginal.placa;
    this.data_local.periodoCarregamento = this.periodoArray[1].data;

    if (!this.data_local.idMotoristaViagem) {
        this.data_local.condutor = null;
    }

    this.map = new window.google.maps.Map(document.getElementById('map'), {
        center: new window.google.maps.LatLng(-5, -42),       
        gestureHandling: 'greedy',
        zoom: 8,
        controlSize: 20,
        fullscreenControl:true,
        streetViewControl: false,
        zoomControl: true,
        zoomControlOptions: {
            position: window.google.maps.ControlPosition.LEFT_TOP
        }
    }); 

    let _self = this;
    window.google.maps.event.addListenerOnce(_self.map, 'tilesloaded', function(){        	
        _self.directionsService = new window.google.maps.DirectionsService();
        _self.directionsService2 = new window.google.maps.DirectionsService();
        _self.directionsService3 = new window.google.maps.DirectionsService();

        _self.directionsDisplay = new window.google.maps.DirectionsRenderer();
        _self.directionsDisplay2 = new window.google.maps.DirectionsRenderer();
        _self.directionsDisplay3 = new window.google.maps.DirectionsRenderer();

        _self.directionsDisplay.setMap(_self.map);       
        _self.directionsDisplay2.setMap(_self.map);
        _self.directionsDisplay3.setMap(_self.map);	

        _self.directionsDisplay.addListener('directions_changed', function() {
            _self.linhaEncoded = '';
            _self.distanciaTotal = 0;
            _self.duracaoTotal = 0;
            _self.polylineViagem = new window.google.maps.Polyline({ path: [], strokeColor: '#FF0000', strokeWeight: 9 });
            var myRoute;
            if (_self.directionsDisplay.getDirections() != null && _self.directionsDisplay.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }
                
            if (_self.directionsDisplay2.getDirections() != null && _self.directionsDisplay2.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay2.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }
                
            if (_self.directionsDisplay3.getDirections() != null && _self.directionsDisplay3.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay3.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }

            if (_self.listaCidadesRota.length > 0) {
                for (var index = 0; index < _self.listaCidadesRota.length; index++) {
                    _self.desenharPoI(_self.listaCidadesRota[index].lat, _self.listaCidadesRota[index].lng, String(index+1));
                }
            }
        });

        _self.directionsDisplay2.addListener('directions_changed', function() {
            _self.linhaEncoded = '';
            _self.distanciaTotal = 0;
            _self.duracaoTotal = 0;
            _self.polylineViagem = new window.google.maps.Polyline({ path: [], strokeColor: '#FF0000', strokeWeight: 9 });
            var myRoute;
            if (_self.directionsDisplay.getDirections() != null && _self.directionsDisplay.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }
                
            if (_self.directionsDisplay2.getDirections() != null && _self.directionsDisplay2.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay2.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }
                
            if (_self.directionsDisplay3.getDirections() != null && _self.directionsDisplay3.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay3.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }

            if (_self.listaCidadesRota.length > 0) {
                for (var index = 0; index < _self.listaCidadesRota.length; index++) {
                    _self.desenharPoI(_self.listaCidadesRota[index].lat, _self.listaCidadesRota[index].lng, String(index+1));
                }
            }
        });

        _self.directionsDisplay3.addListener('directions_changed', function() {
            _self.linhaEncoded = '';
            _self.distanciaTotal = 0;
            _self.duracaoTotal = 0;
            _self.polylineViagem = new window.google.maps.Polyline({ path: [], strokeColor: '#FF0000', strokeWeight: 9 });
            var myRoute;
            if (_self.directionsDisplay.getDirections() != null && _self.directionsDisplay.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }

            if (_self.directionsDisplay2.getDirections() != null && _self.directionsDisplay2.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay2.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }

            if (_self.directionsDisplay3.getDirections() != null && _self.directionsDisplay3.getDirections().routes.length > 0) {
                myRoute = _self.directionsDisplay3.getDirections().routes[0];
                _self.calcularDistancia(myRoute);
            }

            if (_self.listaCidadesRota.length > 0) {
                for (var index = 0; index < _self.listaCidadesRota.length; index++) {
                    _self.desenharPoI(_self.listaCidadesRota[index].lat, _self.listaCidadesRota[index].lng, String(index+1));
                }
            }
        });

        if (_self.registroOriginal.hasOwnProperty('id')) {
            _self.carregarDadosControle();
        } else {
            if (_self.pontoInteresseSaida && _self.pontoInteresseChegada) {
                _self.desenharPoISaida(_self.pontoInteresseSaida);
                _self.desenharPoIChegada(_self.pontoInteresseChegada);                               
            }
        }
	});

    this.fetchListaPoI();
    this.fetchListaZonas();
    this.fetchListaRotasControleViagem();
    this.fetchListaEquipamentos();
    this.fetchTipoOcorrencias();
    this.fetchCombustiveisDoVeiculo();

    if (this.registroOriginal.hasOwnProperty('id')) {
        if (this.registroOriginal.hasOwnProperty('listaCidadesRota')) {
            this.carregarListaCidadesNaGrid(this.registroOriginal.listaCidadesRota, this.registroOriginal.listaLatLng);                    
        }
    } else {
        this.fetchTiposDespesa();
        this.fetchTipoReceitas();
    }
  },
  computed: { 
    temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    temPermissaoGravar(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.grupoPodeSeAlterar;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },     
    exibirCampoTipoCombustivel(){
        return generico.isAbastecimentoExterno(this.data_local.tipoDespesa);
    },
    exibirCampoTanqueCombustivel(){
        return generico.isAbastecimentoInterno(this.data_local.tipoDespesa);        
    },
    validateForm() {
      return !this.errors.any()
    },   
    distanciaFormatada() {
        return generico.formatarNumero3Decimais(this.distanciaTotal / 1000.0);
    },
    duracaoFormatada() {
        return generico.segundosParaHMS(this.duracaoTotal);
    },
    consumoCombustivelFormatada() {
        if (this.distanciaTotal && this.data_local.autonomia) {
            return generico.formatarNumero((this.distanciaTotal / 1000.0)/this.data_local.autonomia);
        } else {
            return "-";
        }
    },
    isPopUpMotoristaValido() {
      return (this.configuracaoPopUpMotoristas.motoristasDoPopUp !== null && this.configuracaoPopUpMotoristas.motoristasDoPopUp.length > 0);
    },
    getUrlPost() {
      return axios.defaults.baseURL + "/ControlarRetornoVeiculosCliente";
    },
    isImportacaoInvalida() {
        if (this.pontoInteresseSaida === null) {
            return true;
        }
        if (this.pontoInteresseChegada === null) {
            return true;
        }

        if (this.data_local.hasOwnProperty('id')) {
            return true;
        }

        return false;
    },
    getTextoImportacaoValida() {
        if (this.pontoInteresseSaida === null) {
            return "Para importar um arquivo você deve selecionar o ponto de interesse do campo DE"
        }
        if (this.pontoInteresseChegada === null) {
            return "Para importar um arquivo você deve selecionar o ponto de interesse do campo PARA"
        }

        if (this.data_local.hasOwnProperty('id')) {
            return "Não é possível importar na edição de uma viagem. Você deve cria uma nova viagem.";
        }

        return "Clique aqui para importar uma viagem através de um arquivo excel exportado do WINTHOR";
    },
    isPopUpTipoCombustivelValido() {
      return (this.configuracaoPopUpTipoCombustivel.itensDoPopUp !== null && this.configuracaoPopUpTipoCombustivel.itensDoPopUp.length > 0);
    },    
    isPopUpTanqueCombustivelValido() {
      return (this.configuracaoPopUpTanqueCombustivel.itensDoPopUp !== null && this.configuracaoPopUpTanqueCombustivel.itensDoPopUp.length > 0);
    },        
    tipoCombustivelSelecionado: {
        get () {
            return (!this.data_local || !this.data_local.idTipoCombustivel ? "" : this.data_local.nomeTipoCombustivel);
        }
    },
    tanqueCombustivelSelecionado: {
        get () {
            return (!this.data_local || !this.data_local.idTanqueCombustivel ? "" : this.data_local.numeroTanqueCombustivel);
        }
    },
  },
  watch: {
      isArquivoProcessado: function(val) {
          if (val) {          
              this.data_local.controlarItinerario = true;      
              this.carregarListaCidadesNaGrid(this.data_local.listaCidadesRota, this.data_local.listaLatLng);
              this.gerarRota();
          }
      }
  },
  methods: {  
    alterarTanqueCombustivel() {
      this.data_local.idTanqueCombustivel = this.configuracaoPopUpTanqueCombustivel.itensDoPopUp[0].id;      
      this.data_local.numeroTanqueCombustivel = this.configuracaoPopUpTanqueCombustivel.itensDoPopUp[0].numero;
    },
    abrirPopUpTanqueCombustivel() {     
      this.configuracaoPopUpTanqueCombustivel.itensDoPopUp = null;
      this.configuracaoPopUpTanqueCombustivel.exibirPopUp = true;
    },
    onSelecionarTanqueCombustivel(itensSelecionados) {            
      this.configuracaoPopUpTanqueCombustivel.itensDoPopUp = itensSelecionados;                  
    }, 
    fecharPopUpTanqueCombustivel() {
          this.configuracaoPopUpTanqueCombustivel.itensDoPopUp = null;
    },
    alterarTipoCombustivel() {
        console.log('Chamou 1');
      this.data_local.idTipoCombustivel = this.configuracaoPopUpTipoCombustivel.itensDoPopUp[0].id; 
      this.data_local.nomeTipoCombustivel = this.configuracaoPopUpTipoCombustivel.itensDoPopUp[0].nome; 
      console.log('Chamou 2');
    },
    abrirPopUpTipoCombustivel() {     
      this.configuracaoPopUpTipoCombustivel.itensDoPopUp = null;
      this.configuracaoPopUpTipoCombustivel.exibirPopUp = true;
    },
    onSelecionarTipoCombustivel(itensSelecionados) {            
      this.configuracaoPopUpTipoCombustivel.itensDoPopUp = itensSelecionados;                  
    }, 
    fecharPopUpTipoCombustivel() {
          this.configuracaoPopUpTipoCombustivel.itensDoPopUp = null;
    },
    changeTipoDespesa(){
        if (this.data_local.idVeiculo)  {
            if (this.data_local.tipoDespesa && this.data_local.tipoDespesa.indexOf('Abastecimento') != -1 && this.data_local.tipoDespesa.indexOf('Interno') == -1) {
                if (this.listCombustiveisSelecionados && this.listCombustiveisSelecionados.length > 0) {
                    this.data_local.idTipoCombustivel = this.listCombustiveisSelecionados[0].id; 
                    this.data_local.nomeTipoCombustivel = this.listCombustiveisSelecionados[0].nome; 
                } else {
                    this.data_local.idTipoCombustivel = null; 
                    this.data_local.nomeTipoCombustivel = null; 
                }
            } else {
                this.data_local.idTipoCombustivel = null; 
                this.data_local.nomeTipoCombustivel = null; 
            }
        }
    },  
    adicionarPoInaRota() {
        if (this.listaCidadesRota === null) {
            this.listaCidadesRota = [];
        }

        this.listaCidadesRota.push({"letra": this.convert(this.listaCidadesRota.length), "numero":"-", "nomeCidade": this.poiSelecionado.nome, "lat": this.poiSelecionado.latitude, "lng": this.poiSelecionado.longitude});
        this.poiSelecionado = null;
        this.gerarRota();
    },
    calcularDataRetorno() {
        if (!this.dialogExibirCalculoDataRetorno && !this.data_local.hasOwnProperty('id') && this.data_local.dataPrevistaSaidaEmMilisegundos && this.duracaoTotal) {            
            this.$vs.dialog({ type: 'confirm', color: 'primary', title: `Atenção ?`,
                    text: 'Deseja calcular a data de retorno baseado no trajeto ?', acceptText: 'SIM', cancelText: 'NÃO',
                    accept: this.calcularDataRetornoRequest, cancel: this.fecharDialogCalcularDataRetorno })
            this.dialogExibirCalculoDataRetorno = true;
        }
    } ,
    fecharDialogCalcularDataRetorno() {
        this.dialogExibirCalculoDataRetorno = false;      
    },
    calcularDataRetornoRequest(){        
        let saida = parseFloat(this.data_local.dataPrevistaSaidaEmMilisegundos)*1000;        
        let duracaoEmMilisegundos = parseFloat(this.duracaoTotal)*1000;
        let duracaoRestante = duracaoEmMilisegundos
        let dataCorrente = new Date(saida);
        let dataFim  = new Date(dataCorrente);
        
        while (duracaoRestante > 0) {    
            if (duracaoRestante > 60*60*1000) {
                dataCorrente.setTime(dataCorrente.getTime() + 60*60*1000);
            } else {        
                dataCorrente.setTime(dataCorrente.getTime() + duracaoRestante);
            }
           
            if (dataCorrente.getHours() > 18) {
                dataCorrente.setHours(18);
                dataCorrente.setMinutes(0);
                dataCorrente.setSeconds(0);
                dataCorrente.setMilliseconds(0);              
                duracaoRestante = duracaoRestante - (dataCorrente.getTime() - dataFim.getTime());                
                dataCorrente.setTime(dataCorrente.getTime() + 14*60*60*1000); // Passar para o proximo dia.                                
            } else if (dataCorrente.getHours() > 11 && dataCorrente.getHours() < 14) {
                dataCorrente.setHours(12);
                dataCorrente.setMinutes(0);
                dataCorrente.setSeconds(0);
                dataCorrente.setMilliseconds(0);              
                duracaoRestante = duracaoRestante - (dataCorrente.getTime() - dataFim.getTime());                
                dataCorrente.setTime(dataCorrente.getTime() + 2*60*60*1000); // Passar para às 14 do mesmo dia.                
            } else {
                duracaoRestante = duracaoRestante - (dataCorrente.getTime() - dataFim.getTime());
            }

            dataFim.setTime(dataCorrente.getTime());                        
        }
        
        this.data_local.dataPrevistaRetornoEmMilisegundos = String(parseFloat(dataFim.getTime()/1000));  

        //this.data_local.dataPrevistaRetornoEmMilisegundos = String(parseFloat(this.data_local.dataPrevistaSaidaEmMilisegundos) + parseFloat(this.duracaoTotal));  
        this.dialogExibirCalculoDataRetorno = false;     

    },
    fetchTipoOcorrencias() {      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        axios.post("/TiposErrosRotasRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                this.listaTipoOcorrencia = response.data;
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista Fornecedor - " + error); 
        })    
    }, 
    adicionarNovaOcorrencia() {
        this.dadosDaGridOcorrencias.push({tipoErro: {id: this.tipoOcorrenciaSelecionada.id, nome: this.tipoOcorrenciaSelecionada.nome}, status: 'PENDENTE', tratativa: ''});
    },
    listaOcorrenciasDaViagem() {
        const params = new URLSearchParams();
        params.append('idCliente', this.$store.state.AppActiveUser.id);      
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);   
        params.append('controleRetorno.ultimoHistorico.uuid', this.data_local.uuidUltimoHistorico );
                
        axios.post("/rest/OcorrenciaControleRetornoVeiculos/Listar", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              if (response.data.Resultado.quantidade > 1) {
                  this.dadosDaGridOcorrencias = response.data.Resultado.lista.item;
              } else if (response.data.Resultado.quantidade === 1) {
                  this.dadosDaGridOcorrencias = [];
                  this.dadosDaGridOcorrencias.push(response.data.Resultado.lista.item);
              } else {
                  this.dadosDaGridOcorrencias = [];
              }
          }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista listaOCorrenciasDoItinerario - " + error); 
        })    
    },
    gravarOcorrenciasViagem() {        
        this.$vs.loading();  
        const params = new URLSearchParams();        
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);        
        params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa); 
        params.append('controleRetorno.cliente.id', this.$store.state.AppActiveUser.id);        
        params.append('controleRetorno.condutorViagem.id', this.data_local.idMotoristaViagem );
        params.append('controleRetorno.ultimoHistorico.uuid', this.data_local.uuidUltimoHistorico );
        params.append('JSONItems', JSON.stringify(this.dadosDaGridOcorrencias));
        
        axios.post("/rest/OcorrenciaControleRetornoVeiculos/AtualizarOcorrenciasDaViagem", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                if (response.data.hasOwnProperty("error")) {
                    this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.listaOcorrenciasDaViagem();
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravarOcorrenciasViagem - " + error); 
        })  
    },  
    abrirPopUpOcorrencias() {
        this.popUpOcorrencias.popupActive = true;        
        this.dadosDaGridOcorrencias = null;
        this.dadosDaGridOcorrencias = [];
        this.listaOcorrenciasDaViagem(); 
    },  
    getTooltipMotivoAceite(){
        if (this.data_local.motivoAceite) {
            return this.data_local.motivoAceite;
        }

        return null;
    },
    getTooltipDataHoraAceite(){
        if (this.data_local.dataHoraAceite && this.data_local.dataHoraAceite !== '-') {
            return "Aceite em " + this.data_local.dataHoraAceite;
        }

        return null;
    },
    iniciarViagemManual() {        
        this.$vs.loading();
        
        const params = new URLSearchParams();            
        params.append('outputFormat', 'JSON');
        params.append('acao', 'INICIAR_VIAGEM_MANUAL');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        params.append('idVeiculo', this.data_local.idVeiculo);        
        params.append('dataRealizadaSaidaEmMilisegundos', this.popUpInicioManualViagem.dataRealizadaSaida*1000);        
        if (this.popUpInicioManualViagem.odometroSaida) {
            params.append('odometroSaidaEmKM', this.popUpInicioManualViagem.odometroSaida);        
        }

        if (this.popUpInicioManualViagem.horimetroSaida) {
            params.append('horimetroSaidaEmHoras', this.popUpInicioManualViagem.horimetroSaida);        
        }
        
        axios.post("/GravarAjustaDataRealizadaControleRetornoViagem", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {          
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {              
                this.$router.push({ path: '/login' });
            } else {
                
                this.$vs.loading.close();                                  
                this.popUpInicioManualViagem.mensagem = response.data.mensagem;                
                if (this.popUpInicioManualViagem.mensagem.indexOf('Erro') == -1 ) {    
                    this.popUpInicioManualViagem.popupActive = false;                
                    this.data_local.dataRealizadaSaidaEmMilisegundos = this.popUpInicioManualViagem.dataRealizadaSaida*1000;
                } else {                    
                    this.popUpInicioManualViagem.exibirMensagem = true;
                }          
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - excluirHistoricoViagem - " + error); 
            this.$vs.loading.close();
        })
    }, 
    terminoViagemManual() {        
        this.$vs.loading();
        
        const params = new URLSearchParams();            
        params.append('outputFormat', 'JSON');
        params.append('acao', 'FINALIZAR_VIAGEM_MANUAL');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        params.append('idVeiculo', this.data_local.idVeiculo);        
        params.append('dataRealizadaRetornoEmMilisegundos', this.popUpTerminoManualViagem.dataRealizadaRetorno*1000);        
        if (this.popUpTerminoManualViagem.odometroRetorno) {
            params.append('odometroRetornoEmKM', this.popUpTerminoManualViagem.odometroRetorno);        
        }

        if (this.popUpTerminoManualViagem.horimetroRetorno) {
            params.append('horimetroRetornoEmHoras', this.popUpTerminoManualViagem.horimetroRetorno);        
        }
        
        axios.post("/GravarAjustaDataRealizadaControleRetornoViagem", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {          
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {              
                this.$router.push({ path: '/login' });
            } else {                
                this.$vs.loading.close();                                  
                this.popUpTerminoManualViagem.mensagem = response.data.mensagem;
                if (this.popUpTerminoManualViagem.mensagem.indexOf('Erro') == -1 ) {                    
                    this.popUpTerminoManualViagem.popupActive = false;                
                    this.data_local.dataRealizadaRetornoEmMilisegundos  = this.popUpTerminoManualViagem.dataRealizadaRetorno*1000;
                } else {                                        
                    this.popUpTerminoManualViagem.exibirMensagem = true;                
                }
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - excluirHistoricoViagem - " + error); 
            this.$vs.loading.close();
        })
    }, 
    abrirPopUpIniciarViagem() {                  
      this.popUpInicioManualViagem.mensagem = null;
      this.popUpInicioManualViagem.exibirMensagem = false;
      this.popUpInicioManualViagem.popupActive = true;
    },
    abrirPopUpTerminarViagem() {                  
      this.popUpTerminoManualViagem.mensagem = null;
      this.popUpTerminoManualViagem.exibirMensagem = false;
      this.popUpTerminoManualViagem.popupActive = true;
    },
    inputFilter: function (newFile) {        
      if (newFile && newFile.xhr && !newFile.xhr.withCredentials) {
            newFile.xhr.withCredentials = true
            this.dadosUpload.placaVeiculo = this.registroOriginal.placa;            
      }
    },
    removeArquivoUpload() {
      this.$refs.upload.remove(this.arquivosParaUpload[0]);
    },
    exibirMensagelResultadoUpload(resposta) {
        if (resposta) {            
            if (resposta.hasOwnProperty("mensagem")) {                
                this.removeArquivoUpload();
                this.data_local = resposta.dados;                
                this.isArquivoProcessado = true;
                this.popupImportacaoArquivo = false;                
                return resposta.mensagem;
            }

            if (resposta.hasOwnProperty("error")) {                
                return resposta.error;
            }
        }
        return "";
    }, 
    carregarListaCidadesNaGrid(listaCidadesConcatenada, listaLatLngConcatenada) {
        if (this.listaCidadesRota == null) {
            this.listaCidadesRota = [];
        } else {
            this.listaCidadesRota = null;
            this.listaCidadesRota = [];
        }

        var arrListaCidades = listaCidadesConcatenada.split("|");
        var arrListaLatLng = listaLatLngConcatenada.split("|");

        var pontoLatLng = [];

        for (var index = 0; index < arrListaCidades.length; index++) {
            pontoLatLng = arrListaLatLng[index].split(",");
            this.listaCidadesRota.push({"letra": this.convert(index+2), "numero":index+1, "nomeCidade":arrListaCidades[index], "lat": pontoLatLng[0], "lng": pontoLatLng[1]});	
        }
    },
    convert(numero){
        var letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W"];
        
        while (numero > 22) {
            numero = numero - 23;
        }
        return letters[numero];
    },
    encontrarCentroPoligono(waypts) {     
        var bounds = new window.google.maps.LatLngBounds();
        try {		                        
            for (var i = 0; i < waypts.length-1; i++) {                
                bounds.extend(waypts[i]);				     
            }
        } catch(err) {
            /* eslint-disable no-console */  console.log(err.message);
        }
        return bounds;
	},	  	
    calcularDistancia(route) {
        if (!route) {
            return;
        }

        for (var i = 0; i < route.legs.length; i++) {
            this.distanciaTotal = this.distanciaTotal + parseFloat(route.legs[i].distance.value);	
            this.duracaoTotal = this.duracaoTotal + parseFloat(route.legs[i].duration.value);	
        }

        // if (!this.data_local.hasOwnProperty('id') && this.data_local.dataPrevistaSaidaEmMilisegundos) {            
        //     this.data_local.dataPrevistaRetornoEmMilisegundos = String(parseFloat(this.data_local.dataPrevistaSaidaEmMilisegundos) + parseFloat(this.duracaoTotal));
        // }
            
        this.linhaEncoded = this.getEncodedPolyline(route);                
    },
    getEncodedPolyline(rota) {
       
        var legs = rota.legs;
        for (var i=0;i<legs.length;i++) {
            
            var steps = legs[i].steps;
            this.polylineViagem.getPath().push(legs[i].start_location);	
            for (var j=0;j<steps.length;j++) {
                var nextSegment = steps[j].path;
                
                for (var k=0;k<nextSegment.length;k++) {
                    this.polylineViagem.getPath().push(nextSegment[k]);		              
                }
            }
            this.polylineViagem.getPath().push(legs[i].end_location);		 
        }

        var encodeString = window.google.maps.geometry.encoding.encodePath(this.polylineViagem.getPath());
        if (encodeString) {
            return encodeString;
        } else {
            return '';
        }		
    },
    getWaypts(pontoInteresseObj) {
        var listaPontos = JSON.parse(pontoInteresseObj.poligonoPoIJSON);
        var latLong = null;
        var coordenadasPerimetro = [];
        for(var i=0; i < listaPontos.length; i++) {                
            latLong = new window.google.maps.LatLng(parseFloat(listaPontos[i].lat), parseFloat(listaPontos[i].long));                                                
            coordenadasPerimetro.push(latLong);            
        }
        return coordenadasPerimetro;
    },
    click_desenharPoISaida(poi) {
        this.desenharPoISaida(poi);
        this.desenharPoIChegada(this.pontoInteresseChegada);
    },
    desenharPoISaida(poi, isGerarRota=true) {
        this.excluiPoISaida();
        this.pontoInteresseSaida = poi;   
        if (poi != null) {            
            var centro = null;
            if (this.pontoInteresseSaida.hasOwnProperty('poligonoPoI')) {
                let bordas = this.encontrarCentroPoligono(this.getWaypts(this.pontoInteresseSaida));
                centro = new window.google.maps.LatLng(bordas.getCenter().lat(), bordas.getCenter().lng());
            } else {
                centro = new window.google.maps.LatLng(parseFloat(this.pontoInteresseSaida.latitude), parseFloat(this.pontoInteresseSaida.longitude));
            }   
            
            if (this.pontoInteresseChegada != null && this.pontoInteresseChegada.id === this.pontoInteresseSaida.id) {
                this.saidaMarker = this.$refs.gmc.addMarkerComIcone(centro, this.map, this.publicPath + "imagens/inicioFim.png"); 
            } else {
                this.saidaMarker = this.$refs.gmc.addMarkerComIcone(centro, this.map, this.publicPath + "imagens/inicio.png"); 
            }
            this.centralizarNoPerimetro();
            if (this.pontoInteresseChegada != null && isGerarRota) {
                this.gerarRota();
            }
        } 
    },   
    excluiPoISaida(){
        if (this.saidaMarker != null){
            this.saidaMarker.setMap(null);
            this.$refs.gmc.deleteMarker(this.saidaMarker);
            this.saidaMarker = null;               
        }
    },
    click_desenharPoIChegada(poi) {
        this.desenharPoIChegada(poi);
        this.desenharPoISaida(this.pontoInteresseSaida);
    },
    desenharPoIChegada(poi, isGerarRota=true) {
        this.excluiPoIChegada();
        this.pontoInteresseChegada = poi;   

        if (poi != null) {            
            var centro = null;
            if (this.pontoInteresseChegada.hasOwnProperty('poligonoPoI')) {
                let bordas = this.encontrarCentroPoligono(this.getWaypts(this.pontoInteresseChegada));
                centro = new window.google.maps.LatLng(bordas.getCenter().lat(), bordas.getCenter().lng());
            } else {
                centro = new window.google.maps.LatLng(parseFloat(this.pontoInteresseChegada.latitude), parseFloat(this.pontoInteresseChegada.longitude));
            } 

            if (this.pontoInteresseSaida != null && this.pontoInteresseSaida.id !== this.pontoInteresseChegada.id) {                
                this.chegadaMarker = this.$refs.gmc.addMarkerComIcone(centro, this.map, this.publicPath + "imagens/fim.png");                 
            } 

            this.centralizarNoPerimetro();
            if (this.pontoInteresseSaida != null && isGerarRota) {
                this.gerarRota();
            }
        }
    },   
    excluiPoIChegada(){
        if (this.chegadaMarker != null){
            this.chegadaMarker.setMap(null);
            this.$refs.gmc.deleteMarker(this.chegadaMarker);
            this.chegadaMarker = null;               
        }
    },
    fetchListaPoI() {                      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('statusAtivo', 'true');
        params.append('pontoDeInicioFim', true);
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        params.append('pageNum', 0); 
        params.append('pageSize', 500000);

        axios.post("/PontoInteresseRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
                this.$vs.loading.close();
            } else {
                this.listaPoI = response.data.lista; 
                this.pontoInteresseSaida = null; 
                this.pontoInteresseChegada = null;
                if (this.registroOriginal.hasOwnProperty('id')) {
                    for(var i=0; i < this.listaPoI.length; i++) {
                         if (this.listaPoI[i].id === this.registroOriginal.idPontoInteresseSaida) {
                            this.pontoInteresseSaida = this.listaPoI[i];                                                         
                         }
                         
                         if (this.listaPoI[i].id === this.registroOriginal.idPontoInteresseChegada) {
                             this.pontoInteresseChegada = this.listaPoI[i];                          
                         }

                         if (this.pontoInteresseSaida && this.pontoInteresseChegada) {
                               this.$vs.loading.close();  
                               break;
                         }
                    }

                    this.desenharPoISaida(this.pontoInteresseSaida, false);
                    this.desenharPoIChegada(this.pontoInteresseChegada);
                } else {
                    for(var j=0; j < this.listaPoI.length; j++) {
                         if (this.listaPoI[j].pontoDeInicioPadrao) {
                             this.pontoInteresseSaida = this.listaPoI[j];                                                          
                         }
                         
                         if (this.listaPoI[j].pontoDeFimPadrao) {
                             this.pontoInteresseChegada = this.listaPoI[j];                                
                         }

                         if (this.pontoInteresseSaida && this.pontoInteresseChegada) {
                               this.$vs.loading.close();  
                               break;
                         }
                    }

                    this.desenharPoISaida(this.pontoInteresseSaida, false);
                    this.desenharPoIChegada(this.pontoInteresseChegada);
                }               
                this.$vs.loading.close();               
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaPoI - " + error); 
        })                            
    },
    fetchListaZonas() {                      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        axios.post("/ZonasViagensRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
                this.$vs.loading.close();
            } else {
                this.listaZonas = response.data;    
                if (this.listaZonas && this.listaZonas.length > 0) {
                    this.data_local.idZonaViagem = this.listaZonas[0].id;
                }            
                this.$vs.loading.close();               
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaZonas - " + error); 
        })                            
    },
    fetchListaEquipamentos() {                      
        const params = new URLSearchParams();      
        params.append('pagina', -1);
        
        if (!this.registroOriginal.hasOwnProperty('id')) { 
            //Se não for INSERT trás apenas os ativos.
            params.append('status', true);
        }

        axios.post("/rest/EquipamentoViagem/Listar", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                
                if (response.data.Resultado.quantidade > 1) {
                    this.listaEquipamentos = response.data.Resultado.lista.item;
                } else if (response.data.Resultado.quantidade === 1) {
                    this.listaEquipamentos = [];
                    this.listaEquipamentos.push(response.data.Resultado.lista.item);
                } else {
                    this.listaEquipamentos = [];
                }
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
        })    
                                        
    },
    fetchListaRotasControleViagem() {                      
        const params = new URLSearchParams();
        params.append('method', 'FindAll');
        params.append('orderDirection', 'ASC');
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        
        axios.post("/RotasViagensRestServlet", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
                this.$vs.loading.close();
            } else {
                this.listaRotas = response.data;                
                this.$vs.loading.close();               
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaRotasControleViagem - " + error); 
        })                            
    },
    montarNomeListaCidades(){
        var nomeLista = "";
        for (var index = 0; index < this.listaCidadesRota.length; index++) {
            if (index > 0) {
                nomeLista = nomeLista + "|";
            }
            nomeLista = nomeLista + this.listaCidadesRota[index].nomeCidade ;	
        } 
        return nomeLista;
    },
    montarListaLatLng() {			
        var nomeLista  = "";
        for (var index = 0; index < this.listaCidadesRota.length; index++) {
            if (index > 0) {
                nomeLista = nomeLista + "|";
            }
            nomeLista = nomeLista + this.listaCidadesRota[index].lat + "," + this.listaCidadesRota[index].lng;	
        } 
        return nomeLista;
	},
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();
            const params = new URLSearchParams();        
            params.append('outputFormat', 'JSON');
            params.append('idCliente', this.$store.state.AppActiveUser.id);
            params.append('idVeiculo', this.data_local.idVeiculo);            
            
            if (this.registroOriginal.hasOwnProperty('id')) {
                params.append('acaoControle', 'ATUALIZAR');
            } else {
                params.append('acaoControle', 'NOVO');    
            }
            
            params.append('dataPrevistaSaidaEmMilisegundos',  this.data_local.dataPrevistaSaidaEmMilisegundos*1000);
            params.append('dataPrevistaRetornoEmMilisegundos',  this.data_local.dataPrevistaRetornoEmMilisegundos*1000);

            params.append('idPontoInteresseSaida', this.pontoInteresseSaida.id);
            params.append('idPontoInteresseChegada', this.pontoInteresseChegada.id);

            params.append('identificadoViagem', this.data_local.identificadoViagem);
            params.append('qtdCidadesViagem', this.data_local.qtdCidadesViagem);
            params.append('qtdEntregasViagem', this.data_local.qtdEntregasViagem);
            params.append('pesoViagem', this.data_local.pesoViagem);
            params.append('valorTransportado', this.data_local.valorTransportado);
            params.append('regiaoAtendida', this.data_local.regiaoAtendida);
            params.append('condutor', this.data_local.condutor);
            params.append('idCondutor', this.data_local.idMotoristaViagem);            
            params.append('periodoCarregamento', this.data_local.periodoCarregamento);

            params.append('qtdAjudante', this.data_local.qtdAjudante);
            params.append('idZonaViagem', this.data_local.idZonaViagem);
            params.append('distanciaTotalViagem', this.distanciaTotal);
            params.append('polylineRota', this.linhaEncoded);
            params.append('duracaoDirecaoViagemEmSegundos', this.duracaoTotal);
            
            if (this.listaCidadesRota != null && this.listaCidadesRota.length > 0) {			
                params.append('listaCidadesRota',this.montarNomeListaCidades());
                params.append('listaLatLng', this.montarListaLatLng());
            }

            params.append('permitirIniciarAntesDoPlanejado', this.data_local.permitirIniciarAntesDoPlanejado);
            params.append('alterarMotoristaNoVeiculo', this.data_local.alterarMotoristaNoVeiculo);            
            if (this.data_local.valorAdiantamento) {
                params.append('valorAdiantamento', this.data_local.valorAdiantamento);
            }

            if (this.data_local.idEquipamentoViagem) {
                params.append('idEquipamentoViagem', this.data_local.idEquipamentoViagem);
            }

            if (this.data_local.idEquipamentoViagem2) {
                params.append('idEquipamentoViagem2', this.data_local.idEquipamentoViagem2);
            }

            if (this.data_local.idEquipamentoViagem3) {
                params.append('idEquipamentoViagem3', this.data_local.idEquipamentoViagem3);
            }

            if (this.data_local.statusAceiteMotorista && this.data_local.permitirAposAceite) {
                params.append('statusAceiteMotorista', this.data_local.statusAceiteMotorista);
            }

            params.append('permitirAposAceite', this.data_local.permitirAposAceite);

            if (this.data_local.tipoDespesa && this.data_local.quantidadeDespesa && this.data_local.valorDespesa) {
                params.append('tipoDespesa', this.data_local.tipoDespesa);
                params.append('quantidadeDespesa', this.data_local.quantidadeDespesa);
                params.append('valorDespesa', this.data_local.valorDespesa);                
                params.append('odometroDespesa', this.data_local.odometroAtual);
                params.append('horimetroDespesa', this.data_local.horimetroAtual);

                if (this.data_local.idTanqueCombustivel) {
                    params.append("idTanqueCombustivel", this.data_local.idTanqueCombustivel);
                }

                if (this.data_local.idTipoCombustivel) {
                    params.append("idTipoCombustivel", this.data_local.idTipoCombustivel);
                }

            }

            if (this.data_local.tipoReceita && this.data_local.quantidadeReceita && this.data_local.valorReceita) {
                params.append('tipoReceita', this.data_local.tipoReceita);
                params.append('quantidadeReceita', this.data_local.quantidadeReceita);
                params.append('valorReceita', this.data_local.valorReceita);
            }

            params.append('controlarItinerario', this.data_local.controlarItinerario);            
                    
            axios.post(URL_SERVLET, params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                    this.$router.push({ path: '/login' });
                } else {
                    
                    if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                    } else {
                        this.$router.push({ name: NAME_ROUTE_SEARCH })
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }
         
    },
    voltar() {        
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];

        if (!this.data_local.identificadoViagem) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lIdentificador') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.pontoInteresseSaida) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lDe') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.pontoInteresseChegada) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lPara') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.dataPrevistaSaidaEmMilisegundos) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lDataSaida') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.dataPrevistaRetornoEmMilisegundos) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lDataRetorno') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.condutor) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lMotorista') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.periodoCarregamento) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lPeriodo') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.idZonaViagem) {
            this.errorsValidacao.push("Cadastre pelo menos uma Zona de Viagem antes de fazer o controle simples de viagem.");
        }
       

        if ((this.data_local.controlarItinerario && !this.distanciaTotal) || (this.pontoInteresseSaida.id !== this.pontoInteresseChegada.id && !this.distanciaTotal)) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lDistancia') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        } 

        if (!this.linhaEncoded) {
            this.errorsValidacao.push(this.$t('TeleControleViagem_lPolilinha') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (this.data_local.tipoDespesa && ( !this.data_local.quantidadeDespesa || !this.data_local.valorDespesa)) {
            this.errorsValidacao.push("Preencha todos os campos da despesa.");
        }

        if (this.data_local.tipoReceita && ( !this.data_local.quantidadeReceita || !this.data_local.valorReceita)) {
            this.errorsValidacao.push("Preencha todos os campos da receita.");
        }

        if (this.data_local.tipoDespesa && generico.isAbastecimentoExterno(this.data_local.tipoDespesa)) {
            if (!this.data_local.idTipoCombustivel) {
                this.errorsValidacao.push(this.$t('TelaDespesas_lTipoCombustivel') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
        }

        if (this.data_local.tipoDespesa && generico.isAbastecimentoInterno(this.data_local.tipoDespesa)) {
            if (!this.data_local.idTanqueCombustivel) {
                this.errorsValidacao.push(this.$t('TelaDespesas_lTanqueCombustivel') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
        }

        if (!this.errorsValidacao.length) {
            return true;
        }   
        
      return false;
      
    },      
    centralizarNoPerimetro() {
        var marcadores = this.$refs.gmc.getMarcadores();
        if (marcadores && marcadores.length > 0) {
            var boundPolygon = new window.google.maps.LatLngBounds();
            
            for(var i=0; i < marcadores.length;i++) {                                                                
                boundPolygon.extend(marcadores[i].getPosition());
            }

            this.map.setCenter(boundPolygon.getCenter());
            this.map.fitBounds(boundPolygon);
        }
    },
    limparPontosNoMapa() {
        this.$refs.gmc.deleteMarkers();

        if (this.percursoRotaPath != null) {
            this.percursoRotaPath.setMap(null);
            this.percursoRotaPath = null;
        }

        this.desenharPoISaida(this.pontoInteresseSaida);
        this.desenharPoIChegada(this.pontoInteresseChegada);  
    },       
    abrirPopUpMotoristas() {
        this.configuracaoPopUpMotoristas.mensagemExplicacao = this.$t('TelaAlterarVeiculo_Msg1_PopupMotoristas')
        this.configuracaoPopUpMotoristas.idVeiculoSelecionado = null;
        this.configuracaoPopUpMotoristas.tipoSelecao = 'single';
        this.configuracaoPopUpMotoristas.motoristasDoPopUp = null;
        this.configuracaoPopUpMotoristas.exibirPopUpMotorista = true;
    },
    onSelecionarMotorista(motoristasSelecionados) {            
        this.configuracaoPopUpMotoristas.motoristasDoPopUp = motoristasSelecionados;                  
    },
    alterarMotorista() {
        if (this.configuracaoPopUpMotoristas.tipoSelecao === 'single') {
            // seleção simples          
            this.data_local.condutor = this.configuracaoPopUpMotoristas.motoristasDoPopUp[0].nome;
            this.data_local.idMotoristaViagem = this.configuracaoPopUpMotoristas.motoristasDoPopUp[0].id;
        }      
    },
    fecharPopUpMotoristas() {
        this.configuracaoPopUpMotoristas.motoristasDoPopUp = null;
    },   
    desenharDirecaoNoMapa(waypts, indice) {
        var lat = parseFloat(waypts[0].lat);
        var lng = parseFloat(waypts[0].lng);

        var start = this.$refs.gmc.getLatLng(lat, lng);

        lat = parseFloat(waypts[waypts.length-1].lat);
        lng = parseFloat(waypts[waypts.length-1].lng);

        var end = this.$refs.gmc.getLatLng(lat, lng);

        var pontosDaRota = [];

        for (var i = 1; i < waypts.length-1; i++) {
            lat = parseFloat(waypts[i].lat);
            lng = parseFloat(waypts[i].lng);
            pontosDaRota.push({
                location: this.$refs.gmc.getLatLng(lat, lng),
                stopover:true
            });
        }

        var request;

        if (pontosDaRota.length > 0 ) {
            request = {
                origin: start,
                destination: end,
                waypoints: pontosDaRota,
                optimizeWaypoints: false,
                travelMode: window.google.maps.TravelMode.DRIVING
            };
        } else {
            request = {
                origin: start,
                destination: end,			      
                optimizeWaypoints: false,
                travelMode: window.google.maps.TravelMode.DRIVING
            };
        }

        let _self = this;

        if (indice < 22) {
            this.directionsService.route(request, function(response, status) {
                if (status == window.google.maps.DirectionsStatus.OK) {			      
                    _self.renderer_options.directions = response;	
                    _self.directionsDisplay.setOptions(_self.renderer_options);                             		      
                } 
            });
        } else if (indice < 45) { 
            this.directionsService2.route(request, function(response, status) {
                if (status == window.google.maps.DirectionsStatus.OK) {			      
                    _self.renderer_options2.directions = response;	
                    _self.directionsDisplay2.setOptions(_self.renderer_options2);                   		      
                }
            });
        } else { 
            this.directionsService3.route(request, function(response, status) {
                if (status == window.google.maps.DirectionsStatus.OK) {			      
                    _self.renderer_options3.directions = response;
                    _self.directionsDisplay3.setOptions(_self.renderer_options3);	                     		      
                }
            });
        }
    },      
    plotarRota(waypts) {      	
        if (this.renderer_options.directions != null && this.renderer_options.directions.routes.length > 0) {
            this.directionsDisplay.set('directions', null); 
        }

        if (this.renderer_options2.directions != null && this.renderer_options2.directions.routes.length > 0) {
            this.directionsDisplay2.set('directions', null); 
        }

        if (this.renderer_options3.directions != null && this.renderer_options3.directions.routes.length > 0) {
            this.directionsDisplay3.set('directions', null); 
        }

        this.linhaEncoded = '';
        this.distanciaTotal = 0;
        this.duracaoTotal = 0;
        this.polylineViagem = new window.google.maps.Polyline({ path: [], strokeColor: '#FF0000', strokeWeight: 9 });

        var i,j, tempWaypts,chunk = 23;
        for (i = 0, j = waypts.length; i<j; i+=(chunk-1)) {
            tempWaypts = waypts.slice(i,i+chunk);
            this.desenharDirecaoNoMapa(tempWaypts, i);			    			    
        }
    },
    exibirRotaPreDefinida(rota) {
        this.rotaControleViagemSelecionada = rota;        
        if (this.rotaControleViagemSelecionada) {
            this.carregarListaCidadesNaGrid(this.rotaControleViagemSelecionada.listaCidades, this.rotaControleViagemSelecionada.listaLatLng);            
        } else {
            this.listaCidadesRota = null;
            this.listaCidadesRota = [];
        }

        this.limparPontosNoMapa();
        this.gerarRota()
    },
    gerarRota() {
        var indiceAtual = 1;
        var listaRotasViagensWp = [];
        listaRotasViagensWp.push({"letra": "A", "numero":1, "nomeCidade":this.pontoInteresseSaida.nome, "lat": this.pontoInteresseSaida.latitude, "lng": this.pontoInteresseSaida.longitude});
        indiceAtual++;

        if (this.listaCidadesRota!= null && this.listaCidadesRota.length > 0) {
            listaRotasViagensWp = listaRotasViagensWp.concat(this.listaCidadesRota);
            indiceAtual++;
        } 

        listaRotasViagensWp.push({"letra": this.convert(indiceAtual), "numero":1, "nomeCidade":this.pontoInteresseChegada.nome, "lat": this.pontoInteresseChegada.latitude, "lng": this.pontoInteresseChegada.longitude});
        this.plotarRota(listaRotasViagensWp);
    },
    desenharPolylineViagem(novaPolyline) { 	   
        if (this.percursoRotaPath != null) {
            this.percursoRotaPath.setMap(null);
            this.percursoRotaPath = null;
        }

        this.percursoRotaPath = new window.google.maps.Polyline({
            path: window.google.maps.geometry.encoding.decodePath(novaPolyline),
            geodesic: true,
            strokeColor: "#0273e7",
            strokeOpacity: 0.5,
            strokeWeight: 6
        });

        this.percursoRotaPath.setMap(this.map);	
    },
    carregarDadosControle() {                      
        const params = new URLSearchParams();
        params.append('outputFormat', 'JSON');
        params.append('idCliente', this.$store.state.AppActiveUser.id);
        params.append('idControleRetorno', this.data_local.id);
                
        axios.post("/ListarRetornoVeiculosCliente", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
                this.$vs.loading.close();
            } else {
                this.linhaEncoded = response.data[0].polylineViagem;                
                this.distanciaTotal = response.data[0].distanciaTotalViagemEmMetros;
                this.duracaoTotal = response.data[0].duracaoDirecaoViagemEmSegundos;
                this.desenharPolylineViagem(this.linhaEncoded);
                
                if (this.listaCidadesRota.length > 0) {
                    for (var index = 0; index < this.listaCidadesRota.length; index++) {
                        this.desenharPoI(this.listaCidadesRota[index].lat, this.listaCidadesRota[index].lng, String(index+1));
                    }
                }
                this.centralizarNoPerimetro();
                this.$vs.loading.close();               
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - carregarDadosControle - " + error); 
        })                            
    },   
    abrirPopUpItinerarioViagem() {   
        if (!this.pontoInteresseSaida || !this.pontoInteresseChegada) {
            this.$refs.errosComponent.iniciar();
            this.errorsValidacao = [];
            if (!this.pontoInteresseSaida) {
                this.errorsValidacao.push(this.$t('TeleControleViagem_lDe') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
            }

            if (!this.pontoInteresseChegada) {
                this.errorsValidacao.push(this.$t('TeleControleViagem_lPara') + " " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
            
            this.errorsValidacao.push(this.$t('TeleControleViagem_Msg_DeParaObrigatorio'));
            
        } else {
            this.configuracaoPopUpItinerarioViagem.exibirPopUp  = true;
        }
    },
    desenharPoI(latitude, longitude, titulo) { 
        var lat = parseFloat(latitude);
        var lng = parseFloat(longitude);
        var latlng = this.$refs.gmc.getLatLng(lat, lng);

        var marker = new window.google.maps.Marker({
            position: latlng,
            map: this.map,
            title: titulo,
            label: {text: titulo, color: "white"}    
        });		 

        this.$refs.gmc.getMarcadores().push(marker); 	  
    },
    removerCidadeRota(indice){
        if (this.listaCidadesRota != null && this.listaCidadesRota.length > 0) {            
            this.listaCidadesRota.splice(indice,1);
            this.gerarRota();
        }
    },
    moverCidadeAcima(indiceSelecionado) {
        if (indiceSelecionado > 0) {            
            var itemSelecionado = this.listaCidadesRota[indiceSelecionado];
            var itemAcima = this.listaCidadesRota[indiceSelecionado-1];
            this.listaCidadesRota.splice(indiceSelecionado - 1, 1, itemSelecionado);
            this.listaCidadesRota.splice(indiceSelecionado, 1, itemAcima);
            this.gerarRota();
        }
    },
    moverCidadeAbaixo(indiceSelecionado) {
        if (indiceSelecionado < this.listaCidadesRota.length ) {
            var itemSelecionado = this.listaCidadesRota[indiceSelecionado];
            var itemAbaixo = this.listaCidadesRota[indiceSelecionado+1];
            this.listaCidadesRota.splice(indiceSelecionado + 1, 1, itemSelecionado);
            this.listaCidadesRota.splice(indiceSelecionado, 1, itemAbaixo);
            this.gerarRota();
        }
    },
    fetchTiposDespesa() {      
        const params = new URLSearchParams();      
        params.append('pagina', - 1);
        params.append('status', true);          
        
        axios.post("/rest/TipoDespesaVeiculo/Listar", params, {              
                credentials: 'include',
                responseEncoding: 'iso88591',
                withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {
                if (response.data.Resultado.quantidade > 1) {
                    this.listaTiposDespesas = response.data.Resultado.lista.item;
                } else if (response.data.Resultado.quantidade === 1) {
                    this.listaTiposDespesas = [];
                    this.listaTiposDespesas.push(response.data.Resultado.lista.item);
                } else {
                    this.listaTiposDespesas = [];
                }
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchTiposDespesa - " + error); 
        })              
    },    
    fetchTipoReceitas() {      
      const params = new URLSearchParams();      
      params.append('pagina', -1);
      params.append('status', true);            
      
      axios.post("/rest/TipoReceitaVeiculo/Listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {
              if (response.data.Resultado.quantidade > 1) {
                  this.listaTiposReceitas = response.data.Resultado.lista.item;
              } else if (response.data.Resultado.quantidade === 1) {
                  this.listaTiposReceitas = [];
                  this.listaTiposReceitas.push(response.data.Resultado.lista.item);
              } else {
                  this.listaTiposReceitas = [];
              }
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
    },
    fetchCombustiveisDoVeiculo() {
      if (!this.data_local.idVeiculo)  {
        return;
      }
      const params = new URLSearchParams();      
      params.append('idVeiculo', this.data_local.idVeiculo);

      axios.post("/rest/TanqueCombustivel/ListarTipoCombustivelDoVeiculo", params, {                            
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => { 
          if (response.data.Resultado.quantidade > 1) {		
            this.listCombustiveisSelecionados = response.data.Resultado.lista.item;
          } else if (response.data.Resultado.quantidade == 1) {		
            this.listCombustiveisSelecionados = [];
            this.listCombustiveisSelecionados.push(response.data.Resultado.lista.item);
          } else {
             this.listCombustiveisSelecionados = [];
          }

          this.changeTipoDespesa();
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("Error fetchCombustiveisDoVeiculo " + error);        
      })      
    },
  }
}
</script>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>

<style lang="scss">  
.con-vs-dialog {    
    .vs-dialog {
      max-width: 600px;      
    }
}
</style>